export default {
  wrapper: {
    background: 'linear-gradient(180deg, #E0F2FE 0%, #026AA2 100%)',
    p: '1px',
    borderRadius: '12px',
    maxWidth: '790px',
    mx: 'auto',
  },
  container: {
    backgroundColor: '#F5FBFF',
    p: '32px',
    borderRadius: '11px',
    flexDirection: 'column',
    width: '100%',
    gap: '20px',
  },
  sections: {
    flexDirection: 'column',
    gap: '20px',
  },
  section: {
    gap: '12px',
  },
  sectionIcon: {
    my: '2px',
  },
  sectionText: {
    flexDirection: 'column',
    gap: '4px',
  },
};
